export const selectContextLocalesAction = (contextLocale: string | null): SelectContextLocaleAction => {
    return {
        contextLocale,
        type: 'SELECT_CONTEXT_LOCALE',
    };
};

export default { selectContextLocalesAction };
